import React, { useState } from 'react';

import * as S from './cancellation-and-reschedule-policy.styles';
import ArrowHdIcon from '../../../../icons/ArrowDown';

import CancellationAndRescheduleTable from './cancellation-and-reschedule-table';

import { ICON_BASE_URL } from '@stencil/flights-constants';

const PoliciesUI = ({ penalty, isFirstTab = false }) => {
  const {
    icons: carriers,
    title,
    PenaltyType,
    table_header: tableHeading,
    penalties,
    void_cancellation: voidCancellation
  } = penalty;
  const [expandSection, setExpandSection] = useState(isFirstTab);

  return (
    <S.CnclPolicyWrap>
      <S.CnclPolicySubHd className="dF justifyBetween alignItemsCenter">
        <div className="dF alignItemsCenter">
          {carriers.map((carrier, index) => (
            <img
              key={index}
              src={`${ICON_BASE_URL}v2/app-img/${carrier}.webp`}
              width="24"
              height="24"
              className="marginR8"
            />
          ))}
          <div>
            <span
              className="font14 marginR5 f500"
              dangerouslySetInnerHTML={{ __html: title }}
            ></span>
          </div>
        </div>
        <span className="dF" onClick={() => setExpandSection(!expandSection)}>
          <S.ArrowWrap className="marginL10 curPointFlt">
            <ArrowHdIcon
              width="1rem"
              height="1rem"
              className={`${expandSection ? 'downArw' : ''}`}
            />
          </S.ArrowWrap>
        </span>
      </S.CnclPolicySubHd>

      {expandSection && (
        <S.CancellationWrap>
          <S.CancellationPolicyBlock>
            <div className="marginB15">
              <span className="f500 font14 marginR10">{PenaltyType}</span>
            </div>
            <CancellationAndRescheduleTable
              tableHeading={tableHeading}
              penalties={penalties}
              voidCancellation={voidCancellation}
            />
          </S.CancellationPolicyBlock>
        </S.CancellationWrap>
      )}
    </S.CnclPolicyWrap>
  );
};

function CancellationAndReschedulePolicyUI({ policies, showNote = true }) {
  const { data: fareRulesData = {}, note = '' } = policies;
  const penalityList = fareRulesData?.penalty_list;
  return (
    <>
      {penalityList &&
        penalityList?.map((penalty, index) => {
          return <PoliciesUI penalty={penalty} key={penalty?.sector} isFirstTab={index === 0} />;
        })}
      {(note && showNote && (
        <div className="marginT15 greyCnt font14" dangerouslySetInnerHTML={{ __html: note }}></div>
      )) ||
        null}
    </>
  );
}

export default CancellationAndReschedulePolicyUI;
